import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel mx-6"
};
const _hoisted_2 = {
  class: "data-table-shell wealth-contract-table-layout"
};
const _hoisted_3 = {
  class: "data-table-scroll wealth-contract-table-scroll"
};
const _hoisted_4 = {
  class: "data-table text-sm"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "data-table-td"
};
const _hoisted_8 = {
  class: "font-medium text-slate-900"
};
const _hoisted_9 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "data-table-td is-right money-text text-slate-900"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "data-table-td text-xs text-slate-600"
};
const _hoisted_15 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_16 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_22 = {
  class: "grid grid-cols-1 gap-4 rounded-lg border border-slate-200 p-4 md:grid-cols-4"
};
const _hoisted_23 = {
  class: "font-medium text-slate-900"
};
const _hoisted_24 = {
  class: "money-text text-slate-900"
};
const _hoisted_25 = {
  class: "flex justify-center gap-1"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "rounded-lg border border-slate-200"
};
const _hoisted_28 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_29 = {
  class: "data-table-scroll"
};
const _hoisted_30 = {
  class: "data-table text-sm"
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  class: "data-table-td font-mono text-xs"
};
const _hoisted_33 = {
  class: "data-table-td"
};
const _hoisted_34 = {
  class: "data-table-td text-xs"
};
import { onMounted, reactive, ref } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getWealthContractLedgerPage, getWealthContractPage } from '@/api/wealth';
import WealthAttachmentPanel from '../components/WealthAttachmentPanel.vue';
import WealthBatchPanel from '../components/WealthBatchPanel.vue';
import WealthDetailDrawer from '../components/WealthDetailDrawer.vue';
import WealthOperationApplyModal from '../components/WealthOperationApplyModal.vue';
import WealthStatusBadge from '../components/WealthStatusBadge.vue';
import { cleanPayload, contractStatusOptions, formatDate, formatDateTime, formatMoney, PAGE_SIZE_OPTIONS, pagePayload, syncPageResult } from '../utils';
export default {
  __name: 'index',
  setup(__props) {
    const filters = reactive({
      contractNo: '',
      contractName: '',
      wealthCustomerId: null,
      status: ''
    });
    const pagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const rows = ref([]);
    const loading = ref(false);
    const detailVisible = ref(false);
    const selectedContract = ref(null);
    const ledgers = ref([]);
    const applyVisible = ref(false);
    const applyType = ref('INCREASE');
    const applyPreset = ref({});
    async function loadContracts() {
      loading.value = true;
      try {
        const result = await getWealthContractPage(pagePayload(pagination, cleanPayload(filters)));
        rows.value = result?.records || [];
        syncPageResult(pagination, result);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      pagination.page = 1;
      loadContracts();
    }
    function handleReset() {
      Object.assign(filters, {
        contractNo: '',
        contractName: '',
        wealthCustomerId: null,
        status: ''
      });
      handleSearch();
    }
    function handlePageChange(page) {
      pagination.current = page;
      pagination.page = page;
      loadContracts();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      handleSearch();
    }
    async function openDetail(row) {
      selectedContract.value = row;
      detailVisible.value = true;
      const result = await getWealthContractLedgerPage(row.id, {
        page: 1,
        size: 10
      });
      ledgers.value = result?.records || [];
    }
    function openApply(type, contract) {
      applyType.value = type;
      applyPreset.value = {
        contractId: contract.id,
        wealthCustomerId: contract.wealthCustomerId
      };
      applyVisible.value = true;
    }
    function openRollover(batch) {
      applyType.value = 'ROLLOVER';
      applyPreset.value = {
        contractId: selectedContract.value?.id,
        contractName: selectedContract.value?.contractName,
        contractNo: selectedContract.value?.contractNo,
        wealthCustomerId: selectedContract.value?.wealthCustomerId,
        batchId: batch.id,
        batchNo: batch.batchNo
      };
      applyVisible.value = true;
    }
    onMounted(loadContracts);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal mx-6 pt-6"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "财富合同"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查看合同本金、资金批次、流水和合同附件。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: loadContracts
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.contractNo = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入合同编号"
          }, null, 512), [[_vModelText, filters.contractNo]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.contractName = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入合同名称"
          }, null, 512), [[_vModelText, filters.contractName]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.wealthCustomerId = $event),
            type: "number",
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入客户ID"
          }, null, 512), [[_vModelText, filters.wealthCustomerId, void 0, {
            number: true
          }]]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contractStatusOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[14] || (_cache[14] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "合同"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "客户ID"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "当前本金"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "注资日期"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[8] || (_cache[8] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, "加载中...", -1)]))])) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[9] || (_cache[9] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, "暂无合同", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(rows.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(row.contractName), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(row.contractNo), 1)]), _createElementVNode("td", _hoisted_10, _toDisplayString(row.wealthCustomerId), 1), _createElementVNode("td", _hoisted_11, "¥" + _toDisplayString(_unref(formatMoney)(row.currentPrincipalAmount)), 1), _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatDate)(row.signDate)), 1), _createElementVNode("td", _hoisted_13, [_createVNode(WealthStatusBadge, {
            type: "contract",
            value: row.status,
            "show-dot": ""
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatDateTime)(row.createTime)), 1), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情",
            onClick: $event => openDetail(row)
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_17), row.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-success",
            title: "增资",
            "aria-label": "增资",
            onClick: $event => openApply('INCREASE', row)
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1)]))], 8, _hoisted_18)), [[_directive_permission, 'wealth:fund:increase']]) : _createCommentVNode("", true), row.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-warning",
            title: "减资",
            "aria-label": "减资",
            onClick: $event => openApply('DECREASE', row)
          }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 12H4"
          })], -1)]))], 8, _hoisted_19)), [[_directive_permission, 'wealth:fund:decrease']]) : _createCommentVNode("", true), row.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "table-action-button is-danger",
            title: "撤资",
            "aria-label": "撤资",
            onClick: $event => openApply('WITHDRAW', row)
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 16l4-4m0 0l-4-4m4 4H7"
          })], -1)]))], 8, _hoisted_20)), [[_directive_permission, 'wealth:fund:withdraw']]) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge wealth-contract-pagination-sticky",
          pagination: pagination,
          "page-sizes": _unref(PAGE_SIZE_OPTIONS),
          onPageChange: handlePageChange,
          onSizeChange: handleSizeChange
        }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)]), _createVNode(WealthOperationApplyModal, {
          modelValue: applyVisible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => applyVisible.value = $event),
          "operation-type": applyType.value,
          preset: applyPreset.value,
          onSubmitted: loadContracts
        }, null, 8, ["modelValue", "operation-type", "preset"]), _createVNode(WealthDetailDrawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => detailVisible.value = $event),
          title: "财富合同详情",
          subtitle: selectedContract.value?.contractNo
        }, {
          default: _withCtx(() => [selectedContract.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("section", _hoisted_22, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "合同名称", -1)), _createElementVNode("div", _hoisted_23, _toDisplayString(selectedContract.value.contractName), 1)]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "客户ID", -1)), _createElementVNode("div", null, _toDisplayString(selectedContract.value.wealthCustomerId), 1)]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "当前本金", -1)), _createElementVNode("div", _hoisted_24, "¥" + _toDisplayString(_unref(formatMoney)(selectedContract.value.currentPrincipalAmount)), 1)]), _createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "状态", -1)), _createVNode(WealthStatusBadge, {
            type: "contract",
            value: selectedContract.value.status
          }, null, 8, ["value"])])]), _createVNode(WealthBatchPanel, {
            "contract-id": selectedContract.value.id,
            title: "合同批次",
            "show-mode-switch": false
          }, {
            actions: _withCtx(({
              row
            }) => [_createElementVNode("div", _hoisted_25, [selectedContract.value?.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "table-action-button is-warning",
              title: "减资",
              "aria-label": "减资",
              onClick: _cache[5] || (_cache[5] = $event => openApply('DECREASE', selectedContract.value))
            }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M20 12H4"
            })], -1)]))])), [[_directive_permission, 'wealth:fund:decrease']]) : _createCommentVNode("", true), selectedContract.value?.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "table-action-button is-indigo",
              title: "续期",
              "aria-label": "续期",
              onClick: $event => openRollover(row)
            }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M16 3h5v5"
            }), _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 8a9 9 0 00-15.5-3.5"
            }), _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M8 21H3v-5"
            }), _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M3 16a9 9 0 0015.5 3.5"
            })], -1)]))], 8, _hoisted_26)), [[_directive_permission, 'wealth:fund:rollover']]) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["contract-id"]), _createElementVNode("section", _hoisted_27, [_cache[23] || (_cache[23] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-4 py-3"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "合同流水")], -1)), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("table", _hoisted_30, [_cache[22] || (_cache[22] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "流水"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "类型"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "时间")])], -1)), _createElementVNode("tbody", null, [ledgers.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [...(_cache[21] || (_cache[21] = [_createElementVNode("td", {
            colspan: "4",
            class: "data-table-empty"
          }, "暂无流水", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(ledgers.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_32, _toDisplayString(item.ledgerNo), 1), _createElementVNode("td", _hoisted_33, [_createVNode(WealthStatusBadge, {
              type: "operation",
              value: item.operationType
            }, null, 8, ["value"])]), _createElementVNode("td", {
              class: _normalizeClass(["data-table-td is-right money-text", !item.direction ? 'text-slate-900' : item.direction === 'OUT' ? 'text-red-600' : 'text-emerald-600'])
            }, _toDisplayString(item.direction ? item.direction === 'OUT' ? '-' : '+' : '') + "¥" + _toDisplayString(_unref(formatMoney)(item.amount)), 3), _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatDateTime)(item.createTime)), 1)]);
          }), 128))])])])])]), _createVNode(WealthAttachmentPanel, {
            title: "合同附件",
            "biz-type": "CONTRACT",
            "biz-id": selectedContract.value.id,
            "can-manage": true
          }, null, 8, ["biz-id"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "subtitle"])]),
        _: 1
      });
    };
  }
};